import { css } from '@emotion/react';
import mediaQueries from 'hooks/Media';

const reset = css`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  input::placeholder {
  }

  section {
    display: block;
  }
  html {
    scroll-behavior: smooth;
  }
  body {
    font-family: "DM Sans", sans-serif;
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: "";
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  button{
    outline: none;
    border: 0;
    background-color : transparent;
    margin: 0;
    padding: 0;
    cursor : pointer;
    font-family: "DM Sans", sans-serif;
  }
  a{
    text-decoration: none;
    color: initial;
  }

  #root {
    overflow-x: hidden;
  }
  
  .pc{
    display: block !important;
  }
  ${mediaQueries.tablet}{
    .pc{
      display: none !important;
    }
  }

  .mo{
    display: none !important;
  }
  ${mediaQueries.tablet}{
    .mo{
      display: block !important;
    }
  }
`;

export default reset;
